import "./WarehouseList.scss";
import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import ModalDelete from "../ModalDelete/ModalDelete";
import sort from "../../assets/Icons/sort-24px.svg";
import right from "../../assets/Icons/chevron_right-24px.svg";
import trash from "../../assets/Icons/delete_outline-24px.svg";
import edit from "../../assets/Icons/edit-24px.svg";

class WarehouseList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      warehouses: [],
      show: false,
      target: "warehouse",
      id: "",
      name: "",
    };
    // Bind this to function hide / show modal so it's assigned to the state
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  componentDidMount() {
    this.getWarehousesData();
    window.scrollTo(0, 0);
  }

  componentDidUpdate() {}

  getWarehousesData() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/warehouses`)
      .then((response) => {
        this.setState({
          warehouses: response.data,
        });
      })

      .catch((err) => {
        console.log(err);
      });
  }
  // function to call to show modal
  showModal = (id, name) => {
    this.setState({ show: true });
    this.setState({ id: id });
    this.setState({ name: name });
  };
  // function to call to hide modal
  hideModal = () => {
    this.setState({ show: false });
  };
  render() {
    // functions for hover event
    return (
      // start of section
      <div className="list">
        <section className="warehouse-list-container">
          {/* start of search bar */}
          <div className="search-bar">
            <h1 className="title">Warehouses</h1>
            <div className="search-container">
              <form className="search">
                <input
                  className="search__input"
                  type="search"
                  id="warehouses-search-input"
                  name="search"
                  placeholder="Search..."
                ></input>
                <input type="submit" hidden />
              </form>
              <Link className="add-button__link" to="/warehouse/new">
                <button className="add-button">+ Add New Warehouse</button>
              </Link>
            </div>
          </div>

          {/* This is the top "sorting" row */}

          <div className="table-header">
            <div className="table-header__column table-header__column--warehouse">
              <p className="table-header__title">WAREHOUSE</p>
              <img
                className="table-header__sort-icon"
                src={sort}
                alt="sort_icon"
              />
            </div>
            <div className="table-header__column table-header__column--address">
              <p className="table-header__title">ADDRESS</p>
              <img
                className="table-header__sort-icon"
                src={sort}
                alt="sort_icon"
              />
            </div>
            <div className="table-header__column table-header__column--contact-name">
              <p className="table-header__title">CONTACT NAME</p>
              <img
                className="table-header__sort-icon"
                src={sort}
                alt="sort_icon"
              />
            </div>
            <div className="table-header__column table-header__column--contact-information">
              <p className="table-header__title">CONTACT INFORMATION</p>
              <img
                className="table-header__sort-icon"
                src={sort}
                alt="sort_icon"
              />
            </div>
            <div className="table-header__column table-header__column--actions">
              <p className="table-header__title">ACTIONS</p>
            </div>
          </div>

          {/* This is the start of the Warehouse List */}

          <ul className="warehouse-list">
            {this.state.warehouses.map((warehouse) => (
              <li className="warehouse-list-item" key={warehouse.id}>
                <div className="warehouse-info">
                  <div className="warehouse-info__box warehouse-info__box--warehouse">
                    <p className="warehouse-info__title">WAREHOUSE</p>
                    <Link
                      className="warehouse-info__warehouse-link"
                      to={`/warehouse/details/${warehouse.id}`}
                    >
                      <div className="warehouse-info__warehouse-link-box">
                        <p className="warehouse-info__text warehouse-info__text--link">
                          {warehouse.name}
                        </p>
                        <img
                          className="warehouse-info__right-chevron-icon"
                          src={right}
                          alt="sort_icon"
                        />
                      </div>
                    </Link>
                  </div>
                  <div className="warehouse-info__box warehouse-info__box--address">
                    <p className="warehouse-info__title">ADDRESS</p>
                    <p className="warehouse-info__text warehouse-info__text--wrap">
                      {warehouse.address + ","}
                    </p>
                    <p className="warehouse-info__text warehouse-info__text--wrap">
                      {warehouse.city + ","}{" "}
                    </p>
                    <p className="warehouse-info__text warehouse-info__text--wrap">
                      {" "}
                      {" " + warehouse.country}
                    </p>
                  </div>
                  <div className="warehouse-info__box warehouse-info__box--contact-name">
                    <p className="warehouse-info__title">CONTACT NAME</p>
                    <p className="warehouse-info__text">
                      {warehouse.contact.name}
                    </p>
                  </div>
                  <div className="warehouse-info__box warehouse-info__box--contact-information">
                    <p className="warehouse-info__title">CONTACT INFORMATION</p>
                    <p className="warehouse-info__text">
                      {warehouse.contact.phone}
                    </p>
                    <p className="warehouse-info__text">
                      {warehouse.contact.email}
                    </p>
                  </div>
                </div>

                {/* action delete and edit below */}

                <div className="actions">
                  {/* this is where I need to add the delete function */}
                  <img
                    className="actions__icon"
                    src={trash}
                    alt="delete_icon"
                    onClick={() => this.showModal(warehouse.id, warehouse.name)}
                  />
                  <Link to={`/warehouse/edit/${warehouse.id}`}>
                    <img className="actions__icon" src={edit} alt="edit_icon" />
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        </section>
        <ModalDelete
          show={this.state.show}
          handleClose={this.hideModal}
          target={this.state.target}
          id={this.state.id}
          name={this.state.name}
        />
      </div>
    );
  }
}

export default WarehouseList;
